<template>
  <div class="col-12">

          <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="tab_empty">
            <div class="row">


              <div class="col-7">
                <div class="row mb-3" style="font-size:13px;">
                  <div class="col"><a class="text-dark" @click="backToPathway()" style="cursor: pointer;"><i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                      Back to pathways</a></div>
                  <div class="col">{{ this.pathwayName }}</div>
                  <div class="col text-right">
                    <button class="btn btn-red btn-md input-height-15 rounded" style="font-size: 13px; padding: 3px 15px;border-radius: 8px !important; margin-top: -5px;" @click="onSubmit()">Edit Pathway</button></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div v-for="(step, index) in pathway_step_obj.steps">
                    <div class="pathways_step rounded shadow mb-3 bg-white" style="border-radius: 15px !important;">
                      <div class="pathways_step_title border-bottom">
                        <div class="row">
                          <div class="col-3">
                            <div class="px-3 py-2">Step {{ parseInt(index + 1) }} - </div>
                          </div>
                          <div class="col-5 font-weight-bold text-center">
                            <div class="px-3 py-2" v-if="step.stepTitle != ''">{{ step.stepTitle }} </div>
                            <div class="px-3 py-2" v-else>Name of step </div>
                          </div>
                          <div class="col-4 text-right">
                            <div class="px-3 py-2">Objectives - {{ step.objective.length }}</div>
                          </div>
                        </div>
                      </div>

                      <!-- Pathway Objective -->
                      <div v-for="(objective, oindex) in step.objective">
                      <div class="pathways_step_item border-bottom" style="background-color: #f0f9fc; border-color: #6cc2e2 !important; ">
                        <div class="row">
                          <div class="col-2">
                            <div class="pl-3 py-2 text-right">

                              <h5 class="mb-0" v-if="objective.objectiveType == 'Assessment'">
                                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Course'">
                                <i class="fa fa-wrench" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'External Course'">
                                <i class="fa fa-wrench" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Task List'">
                                <i class="fa fa-list-ul" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Form'">
                                <i class="fa fa-file-text" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Certificate'">
                                <i class="fa fa-certificate" aria-hidden="true"></i>
                              </h5>



                            </div>
                          </div>
                          <div class="col-8">
                            <div class="pl-3 py-2">{{ objective.objectiveName }}</div>
                          </div>
                          <div class="col-2 text-center">
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      </div>
                      <!-- End Pathway Objective -->


                    </div>
                    </div>




                  </div>
                </div>

              </div>
            </div>
          </div>    

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId', 'pathwayId'],
      data() {
        return {
          pathway_step_obj: {
            pathway: [],
            steps: [],
            removed_objective: [],
          },
          pathwayName: '',
          addStepModalVisible: false,
          addObjectiveModalVisible: false,
          stepTitle: '',
          stepDescription: '',
          stepIndex: '',
          objectiveIndex: '',
          objectiveType: '',
          objectiveId: '',
          objectiveLoading: false,
          objectiveOptions: [],
        }
      },
      methods: {
        backToPathway() {
          this.$parent.selectedComponent = 'PathwaysTab';
        },
        onSubmit() {
          this.$parent.selectPathwayStepTab(this.pathwayId);
        },
        getPathwayStepDetails: function() {
          axios.get('/get-pathway-step-details', {
            params: {
              pathwayId: this.pathwayId,
            }
          })
          .then((resp) => {
              this.pathway_step_obj.pathway = resp.data.pathway;
              this.pathwayName = this.pathway_step_obj.pathway.name;
              this.pathway_step_obj.steps = resp.data.pathwayStep;
              if(this.pathway_step_obj.steps.length == 0) {
                this.pathway_step_obj.steps.push({
                  id: '',
                  stepTitle: '',
                  stepDescription: '',
                  objective: [],
                  edit: false,
                  update: false,
                  modified: false,
                });
              }
              this.$store.dispatch('pathway_steps', this.pathway_step_obj);
           })
          .catch(error => {
            if(error.response.data.message == 'Access denied.') {
              router.push("/forbidden");
            }
          });

        },
      },
      created() {
        this.getPathwayStepDetails();
      },
}

</script>

<style scoped>
.fa-pencil {
  cursor: pointer;
}
.pathway_objectives_box .d-flex div {
  width: 85px;
  margin-bottom: 15px;
  cursor: pointer;
}
.pathway_objective_focus {
  color: #00ACEE !important;
  background-color: #f0f9fc !important;
  border-color: #6cc2e2 !important;
  border: 1px solid #6cc2e2 !important;
}
.custom-control-label {
  font-size: 14px;
  margin-top: 3px;

}
.custom-radio .custom-control-label::before {
  top: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_showpathway.vue